module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/Ham_menu.04090ea8.svg";